import { InputStateInterface } from 'common/module/input/state.interface';
import { InputValidatorInterface } from 'common/module/input/validator.interface';

export class InputValidatorEmail implements InputValidatorInterface {
  /**
   * Constructor
   */
  constructor(protected message: string, protected optional?: boolean) {}

  /**
   * @inheritDoc
   */
  public getError(value: string, context: { [key: string]: InputStateInterface }): string {
    if (this.optional && value === '') {
      return '';
    }
    return !value.match(
      // tslint:disable-next-line
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
    )
      ? this.message
      : '';
  }
}
